import { BaseObject, IBaseObject } from './BaseObject';

export interface ILog extends IBaseObject {
  idSousSysteme: number;
  nomSousSysteme: string;
  dateHeure: string;
  utilisateur: string;
  ipUtilisateur: string;
  idNiveauLog: number;
  descriptionNiveauLog: string;
  niveauInterneSousSysteme: string;
  message: string;
}

export class Log extends BaseObject {
  idSousSysteme!: number;
  nomSousSysteme!: string;
  dateHeure!: Date;
  utilisateur!: string;
  ipUtilisateur!: string;
  idNiveauLog!: number;
  descriptionNiveauLog!: string;
  niveauInterneSousSysteme!: string;
  message!: string;

  constructor(args?: ILog) {
    super(args);

    if (args) {
      Object.assign(this, args);
      this.dateHeure = new Date(args.dateHeure);
    }
  }
}
